var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.VueAvatar,{attrs:{"src":_vm.src,"username":_setup.croppedName,"initials":_vm.initials,"size":_vm.size,"color":_vm.color,"customStyle":_vm.customStyle,"backgroundColor":_vm.backgroundColor}})
}
var staticRenderFns = []

export { render, staticRenderFns }